import React, {
  useEffect,
  useState,
  FunctionComponent,
  Suspense,
} from 'react';
import { useLocation } from '@reach/router';
import axios from 'axios';

import useWidgetQuery from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/hooks/useWidgetQuery';

import { ProviderBaseProps } from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/types';

import { DEFAULT_CRYPTO } from '../../constants';
import MoonpayWidget from '../MoonpayWidget/MoonpayWidget';
import OnRamperWidget from '../OnRamperWidget/OnRamperWidget';

interface ExtendedProps extends ProviderBaseProps {
  address: string;
  isSell?: boolean;
}

interface AddressMap {
  BTC: string;
  BCH: string;
  ETH: string;
  SOL: string;
  POL: string;
  BSC: string;
  DOGE: string;
  XRP: string;
  AVAX: string;
  [key: string]: string;
}

interface StytchUser {
  user_id: string;
  emails: Array<{ email: string; email_id: string; verified: boolean }>;
  phone_numbers: Array<{ phone_number: string }>;
  name?: {
    first_name?: string;
    last_name?: string;
  };
}

interface Props {
  provider?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  crypto?: string;
  addresses: AddressMap | null;
  user: StytchUser | null;
}

const SignInWidget: FunctionComponent<Props> = ({
  provider,
  crypto: cryptoProp,
  addresses,
  user,
}) => {
  const { state, search } = useLocation();

  const [countryCode, setCountryCode] = useState('');
  const [isLoading, setIsLoading] = useState(true)

  const moonpaySupportCountry = [
    "AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES",
    "FI", "FR", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LU",
    "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK",
    "UK", "US", "GB"
  ]

  useEffect(() => {
    axios
      .get('https://neko-web.api.wallet.bitcoin.com/api/v1/location/info')
      .then(response => {
        if (response.data.countryCode) {
          setCountryCode(response.data.countryCode);
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.error('Error fetching geolocation:', err);
        setIsLoading(false);
      });
  }, []);

  const query = useWidgetQuery(search);

  const queryOrState = { ...(state as ExtendedProps), ...query };

  const { crypto, amount, fiat } = queryOrState;

  const cryptoExtract = cryptoProp?.toUpperCase();

  return (
    <Suspense>
      {!isLoading && !provider && !moonpaySupportCountry.includes(countryCode) && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell
          addresses={addresses}
          user={user}
          style={{ height: 650, border: 'none', width: '100%' }}
        />
      )}
      {!isLoading && !provider && moonpaySupportCountry.includes(countryCode) && (
        <MoonpayWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          addresses={addresses}
          user={user}
        />
      )}
    </Suspense>
  );
};

export default SignInWidget;
